import { useState, useEffect } from "react";
import { useDisaplayBrandStatusQuery, useEnableDisableBrandMutation } from "../../../../Services/HomeAPI";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleRight, faCircleInfo } from "@fortawesome/free-solid-svg-icons";

function AddCategory() {
  // Fetch data from API
  const { data, refetch } = useDisaplayBrandStatusQuery();

  const [extraFields, setExtraFields] = useState({
    guest_checkout_enabled: false,
  });

  useEffect(() => {
    if (data?.data) {
      setExtraFields({
        guest_checkout_enabled: data.data.is_active === 1, // Convert 1 to true
      });
    }
  }, [data]);

  const [apiError, setApiError] = useState(null);
  const [EnableGuestCheckout, { isLoading }] = useEnableDisableBrandMutation();

  // Handle checkbox change
  const handleExtraFieldChange = (e) => {
    const { name, checked } = e.target;
    setExtraFields((prevState) => ({
      ...prevState,
      [name]: checked, // Save as boolean (true/false)
    }));
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    let formData = {
      is_active: extraFields.guest_checkout_enabled ? 1 : 0
    }
    try {
      await EnableGuestCheckout(formData).unwrap();
      alert("Settings updated successfully!");
      refetch(); // Refresh data

      setApiError(null);
    } catch (error) {
      setApiError(error.data?.message || "Something went wrong");
    }
  };

  return (
    <div>
      <h3>Enable/Disable Brand Section</h3>
      <div className="breadcrum mb-4">
        <p>
          <Link to="/home">
            <span>Home</span>
          </Link>
          <FontAwesomeIcon icon={faAngleRight} className="mx-2" />
          <span className="active-link">Edit</span>
        </p>
      </div>
      <div className="content-wrapper">
        <form onSubmit={handleSubmit} encType="multipart/form-data">
          <div className="row">
            <div className="col-md-6 col-sm-6">
              <div className="mb-3">
                <input
                  type="checkbox"
                  id="guest_checkout_enabled"
                  name="guest_checkout_enabled"
                  className="form-check-input"
                  checked={extraFields.guest_checkout_enabled}
                  onChange={handleExtraFieldChange}
                />
                <label
                  htmlFor="guest_checkout_enabled"
                  className="form-check-label ms-2"
                >
                  Enable/Disable Brand bar  <div className="tooltip-container">
                    <FontAwesomeIcon
                      icon={faCircleInfo}
                      className="text-warning mx-2"
                      style={{ cursor: "pointer" }}
                    />
                    <div className="tooltip">If you uncheck the BrandBar section, it will not be displayed on the Home and About pages.</div>
                  </div>
                </label>
              </div>
            </div>
          </div>

          {/* API Error Message */}
          {apiError && <p className="text-danger text-center">{apiError}</p>}

          {/* Submit Button */}
          <button
            type="submit"
            className="btn btn-primary"
            disabled={isLoading}
          >
            {isLoading ? "Submitting..." : "Submit"}
          </button>
        </form>
      </div>
    </div>
  );
}

export default AddCategory;
